<form class="form" [formGroup]="form">
  <p class="form-description">
    This client will receive an email invitation to create an account on SonderMind. They'll appear as a client in your portal.
  </p>
  <div class="form-row" fxLayout.gt-xs="row" fxLayout.lt-sm="column" fxLayoutGap.gt-xs="16px">
    <div fxFlex.lt-sm="100">
      <iris-form-field fxFill class="large-field">
        <iris-text-input
          type="text"
          formControlName="firstName"
          placeholder="First Name"
          data-test="first-name"
        ></iris-text-input>
      </iris-form-field>
    </div>
    <div fxFlex.lt-sm="100">
      <iris-form-field fxFill class="large-field">
        <iris-text-input
          type="text"
          formControlName="lastName"
          placeholder="Last Name"
          data-test="last-name"
        ></iris-text-input>
      </iris-form-field>
    </div>
    <div fxFlex.lt-sm="100">
      <iris-form-field fxFill class="large-field">
        <iris-text-input
          type="text"
          formControlName="email"
          placeholder="Email"
          data-test="email"
        ></iris-text-input>
      </iris-form-field>
    </div>
  </div>



  <mat-error><form-field-error-below [control]="$any(form)"></form-field-error-below></mat-error>

  <br>

  <div class="form-row" fxLayout.gt-xs="row" fxLayout.lt-sm="column" fxLayoutGap.gt-xs="16px">
    <div fxFlex.lt-sm="100">
      <iris-checkbox formControlName="nonSpnPatient" data-test="invitation">Don’t send this client an account invitation (client billed externally)</iris-checkbox>
    </div>
  </div>

  <br>

  <iris-button-container [alignment]="irisButtonContainerAlignments.END" data-dd-privacy="allow">
    <iris-button
      *ngIf="cancelable"
      (click)="handleCancel($event)"
      [disabled]="saving"
      [type]="irisButtonTypes.SECONDARY"
      aria-label="Cancel Invite Client"
      data-test="cancel-invite-client"
    >Cancel</iris-button>
    <iris-button
      (click)="handleSave($event)"
      [disabled]="saving"
      aria-label="Invite Client"
      data-test="invite-client"
    >Add client</iris-button>
  </iris-button-container>
</form>
